/** @jsx createElement */
import {createElement} from '@wordpress/element';
  
export default function Modal({children, onClose}) {
    return (
        <div className="pacers-modal-overlay open ">
            <div className="pacers-modal-window">
                <button className="pacers-modal-close" onClick={onClose}>×</button>
                {children}
            </div>
        </div>

    );
}
